module.exports = __webpack_public_path__ + "static/when-the-wolves-bite-86db078e162f9320648b6b35442c8ad8.jpg";